import { S } from '../core/estado.js';
import { esc } from '../core/formato.js';
import { db } from '../data/db.js';

/* =====================================================================
   AJUSTES
   ---------------------------------------------------------------------
   Catálogos generales: zonas (área de los usuarios), carreteras (para
   imputaciones y pedidos) y almacenes (destino de descarga de pedidos).
   ===================================================================== */
export const CATALOGOS = {
  zonas:      {coleccion:'zonas',      titulo:'Zonas',       sub:'Unidad o zona a la que se asigna cada usuario'},
  carreteras: {coleccion:'carreteras', titulo:'Carreteras',  sub:'Vías disponibles al registrar trabajo o hacer un pedido'},
  almacenes:  {coleccion:'almacenes',  titulo:'Almacenes',   sub:'Sitios de descarga disponibles al hacer un pedido'},
};

const STOPWORDS = ['de','del','la','las','el','los','y','en'];

/* Código de 2 letras/cifras para el nº de pedido: inicial de la primera
   palabra + inicial de la segunda palabra significativa de la zona.
   "Zona 1" → Z1 · "Servicio de Conservación" → SC · "Intervención" → IN */
export function codigoZona(nombre){
  if(!nombre) return 'ZZ';
  const palabras = nombre.split(/[^\p{L}\p{N}]+/u).filter(w=>w && !STOPWORDS.includes(w.toLowerCase()));
  const p1 = palabras[0]||'', p2 = palabras[1]||p1.slice(1)||'';
  return ((p1[0]||'Z')+(p2[0]||'Z')).toUpperCase();
}

function tablaCatalogo(tipo){
  const lista = db[tipo];
  if(!lista.length) return `<div class="vacio"><h4>Vacío</h4><p>Añade el primero.</p></div>`;
  return `<table><thead><tr><th>Nombre</th><th></th></tr></thead>
    <tbody>${lista.map(x=>`<tr>
      <td>${esc(x.nombre)}</td>
      <td style="white-space:nowrap">
        <button class="btn btn-x" data-act="editar-catalogo" data-tipo="${tipo}" data-id="${x.id}">Editar</button>
        <button class="btn btn-x" data-act="borrar-catalogo" data-tipo="${tipo}" data-id="${x.id}">Eliminar</button>
      </td></tr>`).join('')}</tbody></table>`;
}

function tarjetaTipos(){
  const a = db.ajustes;
  return `<div class="card">
    <div class="card-h"><div><h3>Tipos impositivos</h3>
      <div class="sub">Se aplican a los contratos nuevos. Lo ya certificado conserva el % con el que se calculó.</div></div></div>
    <div class="card-b">
      <div class="fila f3">
        <div class="campo"><label for="aj-iva">IVA (%)</label><input id="aj-iva" type="number" step="0.1" min="0" value="${a.iva}"></div>
        <div class="campo"><label for="aj-bi">Beneficio industrial (%)</label><input id="aj-bi" type="number" step="0.1" min="0" value="${a.beneficioIndustrial}"></div>
        <div class="campo"><label for="aj-gg">Gastos generales (%)</label><input id="aj-gg" type="number" step="0.1" min="0" value="${a.gastosGenerales}"></div>
      </div>
      <button class="btn btn-p" data-act="guardar-tipos">Guardar</button>
    </div></div>`;
}

/* "Tipos impositivos" es una pestaña más junto a los catálogos, aunque no
   viva en CATALOGOS: no es una lista de db[tipo], es el formulario de %. */
export function vistaAjustes(){
  const tab = S.tab==='tipos'||CATALOGOS[S.tab] ? S.tab : 'zonas';
  return `<div class="page-head">
    <div><div class="eyebrow">Administración</div><h1>Ajustes</h1>
      <p>Tipos impositivos y catálogos comunes a todos los contratos: zonas, carreteras y almacenes.</p></div></div>
  <div class="tabs">
    <button class="${tab==='tipos'?'on':''}" data-act="tab" data-t="tipos">Tipos impositivos</button>
    ${Object.entries(CATALOGOS).map(([k,v])=>`<button class="${tab===k?'on':''}" data-act="tab" data-t="${k}">${v.titulo}<span class="n">${db[k].length}</span></button>`).join('')}
  </div>
  ${tab==='tipos' ? tarjetaTipos() : `<div class="card"><div class="card-h"><div><h3>${CATALOGOS[tab].titulo}</h3><div class="sub">${CATALOGOS[tab].sub}</div></div>
    <button class="btn btn-s btn-p" data-act="nuevo-catalogo" data-tipo="${tab}">Añadir</button></div>
    <div class="tabla-wrap">${tablaCatalogo(tab)}</div></div>`}`;
}
